/**
 * Marca de "el deep-link embebido ya se consumio", compartida entre RematePage
 * y AnimalPage.
 *
 * EL PROBLEMA QUE RESUELVE: cuando el micrositio va embebido en el sitio del
 * productor (ej. remates.cabanapilaga.com.ar), el script del embed lee `?animal=`
 * de la URL del parent y lo postea al iframe. Eso tiene que pasar UNA sola vez:
 * despues el visitante navega libre, y el parent —que conserva el `?animal=`
 * viejo en su URL— no puede volver a tirarlo a la ficha.
 *
 * El flag de modulo alcanzaba mientras el unico full reload fuera alguien
 * apretando F5, que es justo cuando SI queremos re-aplicar el deep-link. Pero el
 * countdown de pre-ofertas recarga SOLO cuando la ventana abre o cierra, y esa
 * recarga rearmaba el handshake: a las 08:00, con la pagina llena, el visitante
 * salia del catalogo hacia una ficha que nunca pidio.
 *
 * Por eso la marca viaja en sessionStorage y es DE UN SOLO USO: se borra al
 * leerla, asi que sobrevive a la recarga automatica del countdown pero no a un
 * F5 de verdad, que sigue comportandose como siempre.
 */

const DEEPLINK_FLAG = 'puja:deeplink-consumido';

/** Lee la marca y la consume. true si venimos de una recarga automatica. */
export const leerDeepLinkConsumido = () => {
  try {
    if (sessionStorage.getItem(DEEPLINK_FLAG) === '1') {
      sessionStorage.removeItem(DEEPLINK_FLAG);
      return true;
    }
  } catch { /* sessionStorage bloqueado: iframe con cookies de terceros */ }
  return false;
};

/** Se llama ANTES de una recarga que no pidio el visitante. */
export const marcarDeepLinkConsumido = () => {
  try { sessionStorage.setItem(DEEPLINK_FLAG, '1'); } catch { /* idem */ }
};
